import { render } from "./level_1.svg?vue&type=template&id=9a78aa62"
const script = {}
script.render = render

export default script